import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ROLE_AND_INVITATION_PAGE } from '@/settings/pages';

type Props = {
  children?: never;
  gloplaId: string;
};

export const Information: React.FC<Props> = (props) => {
  const { gloplaId } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Trans i18nKey="text.membership.information.title">
        <H2>タイトル</H2>
      </Trans>
      <Div>
        <Trans i18nKey="text.membership.information.description">
          <P>サービス申込について</P>
          <P>依頼について</P>
        </Trans>
        <Ol>
          <Li>
            <Trans i18nKey="text.membership.information.procedure1">
              <a
                href={ROLE_AND_INVITATION_PAGE}
                rel="noopener noreferrer"
                target="_blank"
              >
                {/* Transで文言を切り替えているため下記は仮置き */}
                ドキュメントリンク
              </a>
            </Trans>
          </Li>
          <Li>
            <Trans i18nKey="text.membership.information.procedure2">
              <a
                href={t('pages.external.inquiry.url')}
                rel="noopener noreferrer"
                target="_blank"
              >
                {/* Transで文言を切り替えているため下記は仮置き */}
                問い合わせフォーム
              </a>
            </Trans>
          </Li>
        </Ol>
        <Ul>
          <Li>{t('text.membership.information.inquiryItem1')}</Li>
          <Li>{t('text.membership.information.inquiryItem2', { gloplaId })}</Li>
          <Li>{t('text.membership.information.inquiryItem3')}</Li>
        </Ul>
      </Div>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  padding: 24px;
  background-color: #ffffff;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
`;

const H2 = styled.h2`
  font-size: 16px;
`;

const Div = styled.div`
  margin-top: 24px;
`;

const P = styled.p`
  margin-bottom: 0.5em;
`;

const Ol = styled.ol`
  padding-left: 16px;
`;

const Ul = styled.ul`
  list-style: none;
  padding-left: 16px;
`;

const Li = styled.li`
  margin-bottom: 0.5em;
`;
